import { PureComponent } from 'react';
import { isNil } from 'lodash';
import { injectIntl } from 'react-intl';
import { region } from 'utils';
import { SelectInput } from './selectField';
import withFormikInput from './withFormikInput';
import withFormField from './withFormField';

function withRegionList(Component) {
  return class RegionListField extends PureComponent {
    static _getRegionListByCountry(country, intl) {
      if (country) {
        return region.getTranslatedRegionsList(country, intl);
      }

      return [];
    }

    render() {
      // @ts-expect-error TS(2339): Property 'options' does not exist on type 'Readonl... Remove this comment to see the full error message
      const { options, ...rest } = this.props;

      // @ts-expect-error TS(2339): Property 'country' does not exist on type '{ child... Remove this comment to see the full error message
      const regions = isNil(options) ? RegionListField._getRegionListByCountry(rest.country, rest.intl) : options;
      return <Component {...rest} options={regions} />;
    }
  };
}

// @ts-expect-error TS(2769): No overload matches this call.
const FormRegionField = withFormikInput(withFormField(injectIntl(withRegionList(SelectInput))), {
  passProps: ['setFieldTouched'],
});
export default FormRegionField;
